import { render, staticRenderFns } from "./M2hBestChoices.vue?vue&type=template&id=306676c3&scoped=true&"
import script from "./M2hBestChoices.vue?vue&type=script&lang=js&"
export * from "./M2hBestChoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306676c3",
  null
  
)

export default component.exports